import Column from './Column'
import ColumnSet from './ColumnSet'
import Container from './Container'
import DeprecatedComponent from './DeprecatedComponent'
import FactSet from './FactSet'
import FallbackElement from './FallbackElement'
import Image from './Image'
import InlineActionSet from './InlineActionSet'
import InputChoiceSet from './InputChoiceSet'
import InputDate from './InputDate'
import InputNumber from './InputNumber'
import InputRange from './InputRange'
import InputText from './InputText'
import InputTime from './InputTime'
import InputToggle from './InputToggle'
import TextBlock from './TextBlock'

class ComponentRegistry {
  getComponent(componentName: any) {
    switch (componentName) {
      case 'Container': {
        return Container
      }
      case 'TextBlock': {
        return TextBlock
      }
      case 'Image': {
        return Image
      }
      case 'ColumnSet': {
        return ColumnSet
      }
      case 'Column': {
        return Column
      }
      case 'FactSet': {
        return FactSet
      }
      case 'InlineActionSet': {
        return InlineActionSet
      }
      case 'Input.Date': {
        return InputDate
      }
      case 'Input.Time': {
        return InputTime
      }
      case 'Input.Number': {
        return InputNumber
      }
      case 'Input.Text': {
        return InputText
      }
      case 'Input.ChoiceSet': {
        return InputChoiceSet
      }
      case 'Input.Range': {
        return InputRange
      }
      case 'Input.Toggle': {
        return InputToggle
      }
      case 'Banner': {
        // @Deprecated (use the Footer now)
        return DeprecatedComponent
      }
      default: {
        return FallbackElement
      }
    }
  }
}

export default new ComponentRegistry()
